import React from 'react';
import { useNavigate } from 'react-router-dom';

const ProjectCard = ({ data }) => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate(`/project/details/${data?.project_name}/${data?.project_id}`);
  };

  return (
    <div
      className="bg-gray-100 rounded-lg p-4 cursor-pointer hover:scale-105 transition-transform ease-in duration-300"
      onClick={() => handleNavigate()}
    >
      <img src="" alt="Project Thumbnail" className="w-full h-24 rounded-lg" />
      <div className="text-base text-gray-900 font-semibold mt-1">
        Project {data?.project_name || 'N/A'}
      </div>
    </div>
  );
};

export default ProjectCard;
